import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component.js"
import {AsyncPaginate} from "react-select-async-paginate"
import Collection from "@kaspernj/api-maker/build/collection.js"
import {defaultSelectProps} from "./nemoa-select-v2"
import Form from "react-bootstrap/Form"
import memo from "set-state-compare/build/memo.js"
import {tenantAtom} from "shared/atoms/tenant-atom"
import {useRecoilValue} from "recoil"

const additional = {page: 1}

export default memo(shapeComponent(class NemoaModelSelectV2 extends ShapeComponent {
  static defaultProps = {
    currentTenantFilter: true
  }

  static propTypes = {
    collection: PropTypes.instanceOf(Collection).isRequired,
    collectionParams: PropTypes.object, // params that are applied to all but the initial query. That is so e.g. soft deleted models can be included
    currentTenantFilter: PropTypes.bool,
    modelToOption: PropTypes.func.isRequired,
    searchParams: PropTypes.string.isRequired
  }

  state = {
    value: undefined,
    isLoading: defaultSelectProps(this.props).defaultValue
  }

  tenant = this.hookField()

  setup() {
    this.tenant = useRecoilValue(tenantAtom)
  }

  selectProps() {
    return defaultSelectProps(this.props)
  }

  onChange = (option) => {
    const {onChange: onChangeFromProps} = this.selectProps()

    if (onChangeFromProps) {
      onChangeFromProps(option)
    } else {
      this.setState({value: option})
    }
  }

  loadOptions = async (search, prevOptions, {page}) => {
    const {collection, collectionParams, currentTenantFilter, modelToOption, searchParams} = this.selectProps()
    const query = collection.clone().page(page)

    if (collectionParams) {
      query.ransack(collectionParams)
    }

    const tenant = this.tt.tenant
    const tenantId = tenant ? tenant.id() : null

    if (currentTenantFilter && tenantId) {
      query.ransack({tenant_id_eq: tenantId})
    }

    if (search) {
      query.ransack({[searchParams]: search})
    }

    const result = await query.result()
    const models = result.models()
    const options = models.map(modelToOption)
    const hasMore = result.totalPages() > result.currentPage()

    return {
      options: prevOptions.concat(options),
      hasMore,
      additional: {page: result.currentPage() + 1}
    }
  }

  syncValueFromProps() {
    this.setState({value: this.selectProps().value})
  }

  async loadInitialOption() {
    const {collection, defaultValue: defaultValueFromProps, modelToOption} = this.selectProps()

    if (!defaultValueFromProps) {
      return
    }

    const initialModels = await collection.clone().ransack({id_in: defaultValueFromProps}).toArray()

    this.setState({value: initialModels.map((model) => modelToOption(model))[0], isLoading: false})
  }

  componentDidMount() {
    this.syncValueFromProps()
    this.loadInitialOption()
  }

  componentDidUpdate(prevProps) {
    if (defaultSelectProps(prevProps).value !== this.selectProps().value) {
      this.syncValueFromProps()
    }
  }

  render() {
    const {id, label, ...restProps} = this.selectProps()
    const {value, isLoading} = this.s

    const select = (
      <AsyncPaginate
        additional={additional}
        id={id}
        isDisabled={isLoading}
        isLoading={isLoading}
        loadOptions={this.loadOptions}
        onChange={this.onChange}
        value={value}
        {...restProps}
      />
    )

    if (label) {
      return (
        <Form.Group>
          {label &&
            <Form.Label htmlFor={id}>
              {label}
            </Form.Label>
          }
          {select}
        </Form.Group>
      )
    }

    return select
  }
}))
